module.exports = __webpack_public_path__ + "img/img_term.5ca31464.png";